module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12 12h7.586l-2.293 2.293 1.414 1.414 4-4c.39-.39.39-1.023 0-1.414l-4-4-1.414 1.414L19.586 10H12c-3.31 0-6 2.69-6 6h2c0-2.205 1.795-4 4-4m12 4c0 2.205-1.795 4-4 4h-7.586l2.293-2.293-1.414-1.414-4 4c-.39.39-.39 1.023 0 1.414l4 4 1.414-1.414L12.414 22H20c3.31 0 6-2.69 6-6h-2z\" clip-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/svg/exchange.svg
// module id = 1514
// module chunks = 0